import { useSelector } from 'react-redux';
import { selectUserInformation } from '@algoan/dashboard/store/selectors';

export const useIsFirstConnectionAfterDashboardRegistration = (): boolean => {
  const userInformation = useSelector(selectUserInformation);
  return !!userInformation && userInformation.isDashboardUser === true && userInformation.organizationId === undefined;
};
